/**
 * SATU daftar rute berperan untuk tampilan rancang ulang (ADR-095 no. 3).
 *
 * Menu, pohon rute, dan penjaga dibaca dari daftar ini; tidak ada daftar kedua. Rumah
 * keputusannya `docs/ANTARMUKA.md` bagian A dan C, dan `periksa_antarmuka.py` menolak
 * kalau keduanya berbeda. SATU ENTRI SATU BARIS: pemeriksa itu membacanya per baris.
 *
 *   kode     kode layar di ANTARMUKA.md
 *   app      'publik', 'tenant' (Tenant Admin dan Tenant Marketing), atau 'smova'
 *   peran    peran terendah yang boleh membukanya
 *   tahap    tahap RENCANA langkah 4 yang membangunnya
 *   alamat   tanpa alamat berarti bagian dari layar lain, atau kerangkanya
 *   tab      tiap tab punya alamat sendiri: `alamat` + '/' + tab
 *   induk    layar yang menunya menyala saat layar ini dibuka
 *   menu     kelompok menunya; tanpa ini layarnya tidak ada di menu
 *   ikon     nama ikon Lucide untuk menunya
 *
 * Yang MENEGAKKAN izin tetap backend, per rute (`ai_worker/app/core/peran_rute.py`).
 * Daftar ini hanya menentukan apa yang ditampilkan dan apa yang diminta.
 */

// prettier-ignore
export const RUTE = [
  { kode: 'B0', app: 'publik', peran: 'publik', tahap: 1, alamat: '/' },
  { kode: 'B1', app: 'publik', peran: 'publik', tahap: 1, alamat: '/masuk' },
  { kode: 'T0', app: 'tenant', peran: 'tenant_marketing', tahap: 2 },
  { kode: 'K1', app: 'tenant', peran: 'tenant_marketing', tahap: 2, alamat: '/hari-ini', menu: 'kerja', ikon: 'Sun' },
  { kode: 'K1a', app: 'tenant', peran: 'tenant_admin', tahap: 2, induk: 'K1' },
  { kode: 'K2', app: 'tenant', peran: 'tenant_marketing', tahap: 2, alamat: '/perlu-dijawab', menu: 'kerja', ikon: 'MessageCircle' },
  { kode: 'K2a', app: 'tenant', peran: 'tenant_admin', tahap: 2, induk: 'K2' },
  { kode: 'K9', app: 'tenant', peran: 'tenant_marketing', tahap: 2, alamat: '/calon-prospek', menu: 'kerja', ikon: 'UserSearch' },
  { kode: 'K3', app: 'tenant', peran: 'tenant_marketing', tahap: 2, alamat: '/prospek', menu: 'kerja', ikon: 'Target' },
  { kode: 'K4', app: 'tenant', peran: 'tenant_marketing', tahap: 2, alamat: '/prospek/:id', tab: ['ringkasan', 'meeting', 'percakapan', 'catatan'], induk: 'K3' },
  { kode: 'K4a', app: 'tenant', peran: 'tenant_admin', tahap: 2, induk: 'K4' },
  { kode: 'K5', app: 'tenant', peran: 'tenant_marketing', tahap: 2, alamat: '/meeting', menu: 'kerja', ikon: 'Calendar' },
  { kode: 'K6', app: 'tenant', peran: 'tenant_marketing', tahap: 2, alamat: '/konten', tab: ['menunggu', 'terjadwal', 'sudah-tayang', 'bahan'], menu: 'kerja', ikon: 'Image' },
  { kode: 'K7', app: 'tenant', peran: 'tenant_marketing', tahap: 2, alamat: '/konten/:id', induk: 'K6' },
  { kode: 'K8', app: 'tenant', peran: 'tenant_marketing', tahap: 2, alamat: '/konten/baru', induk: 'K6' },
  { kode: 'P1', app: 'tenant', peran: 'tenant_admin', tahap: 3, alamat: '/chatbot', tab: ['persona', 'data-prospek', 'jadwal-balas', 'model'], menu: 'pengaturan', ikon: 'Bot' },
  { kode: 'P2', app: 'tenant', peran: 'tenant_admin', tahap: 3, alamat: '/aturan-meeting', menu: 'pengaturan', ikon: 'Clock' },
  { kode: 'P3', app: 'tenant', peran: 'tenant_admin', tahap: 3, alamat: '/konten-otomatis', tab: ['rantai', 'sumber', 'referensi', 'model'], menu: 'pengaturan', ikon: 'Layers' },
  { kode: 'P4', app: 'tenant', peran: 'tenant_admin', tahap: 3, alamat: '/pengetahuan', menu: 'pengaturan', ikon: 'BookOpen' },
  { kode: 'P5', app: 'tenant', peran: 'tenant_admin', tahap: 3, alamat: '/tim', menu: 'pengaturan', ikon: 'Users' },
  { kode: 'P6', app: 'tenant', peran: 'tenant_admin', tahap: 3, alamat: '/sambungan', menu: 'pengaturan', ikon: 'Link' },
  { kode: 'P7', app: 'tenant', peran: 'tenant_admin', tahap: 3, alamat: '/pemakaian', menu: 'pengaturan', ikon: 'Wallet' },
  { kode: 'S1', app: 'smova', peran: 'smova_admin', tahap: 4, alamat: '/ringkasan', menu: 'operasi', ikon: 'House' },
  { kode: 'S2', app: 'smova', peran: 'smova_admin', tahap: 4, alamat: '/tenant', menu: 'operasi', ikon: 'Building2' },
  { kode: 'S3', app: 'smova', peran: 'smova_admin', tahap: 4, alamat: '/tenant/baru', induk: 'S2' },
  { kode: 'S4', app: 'smova', peran: 'smova_admin', tahap: 4, alamat: '/tenant/:id', tab: ['ikhtisar', 'sambungan', 'orang', 'paket', 'aktivitas'], induk: 'S2' },
  { kode: 'S5', app: 'smova', peran: 'smova_admin', tahap: 5, alamat: '/jejak-alur', tab: ['jalan', 'masuk'], menu: 'operasi', ikon: 'Activity' },
  { kode: 'S6', app: 'smova', peran: 'smova_admin', tahap: 4, alamat: '/pemakaian', menu: 'operasi', ikon: 'Wallet' },
  { kode: 'S7', app: 'smova', peran: 'smova_admin', tahap: 4, alamat: '/katalog', tab: ['fitur', 'model'], menu: 'dataInduk', ikon: 'LayoutGrid' },
  { kode: 'S8', app: 'smova', peran: 'smova_admin', tahap: 4, alamat: '/sistem', menu: 'dataInduk', ikon: 'Server' },
]

/**
 * Alamat lama yang pindah. Sisanya tidak perlu ditulis: alamat yang tidak berubah
 * langsung cocok, dan alamat layar bertab tanpa tabnya dibelokkan ke tab pertamanya.
 */
// prettier-ignore
export const BELOKAN = [
  { app: 'smova', dari: '/tenant/:id/onboarding', ke: '/tenant/:id/ikhtisar' },
  { app: 'smova', dari: '/jalur-masuk', ke: '/jejak-alur/masuk' },
  { app: 'tenant', dari: '/beranda', ke: '/hari-ini' },
  { app: 'tenant', dari: '/atur-meeting', ke: '/aturan-meeting' },
  { app: 'tenant', dari: '/atur-konten', ke: '/konten-otomatis/rantai' },
  { app: 'tenant', dari: '/pemakaian-saya', ke: '/pemakaian' },
  { app: 'tenant', dari: '/fitur', ke: '/pemakaian' },
  { app: 'tenant', dari: '/model', ke: '/chatbot/model' },
  { app: 'tenant', dari: '/field-profil', ke: '/chatbot/data-prospek' },
]

export const BERANDA = { tenant: '/hari-ini', smova: '/ringkasan' }

export const ALAMAT_MASUK = '/masuk'

const APLIKASI = { tenant_marketing: 'tenant', tenant_admin: 'tenant', smova_admin: 'smova' }

// Di dalam satu aplikasi, peran yang lebih tinggi memuat yang di bawahnya.
const TANGGA = { tenant_marketing: 1, tenant_admin: 2, smova_admin: 3 }

/** Aplikasi milik sebuah peran, atau null kalau perannya tidak dikenal. */
export function aplikasiPeran(peran) {
  return APLIKASI[peran] ?? null
}

/**
 * Bolehkah orang berperan `peran` membuka `entri`?
 *
 * Aplikasinya harus sama: Smova Admin punya pohon rutenya sendiri dan tidak membuka
 * layar tenant, walaupun backend mengizinkannya memanggil rute tenant dengan
 * `X-Tenant-Id`.
 */
export function boleh(peran, entri) {
  if (entri.peran === 'publik') return true
  if (aplikasiPeran(peran) !== entri.app) return false
  return TANGGA[peran] >= TANGGA[entri.peran]
}

const PETA_KODE = new Map(RUTE.map((e) => [e.kode, e]))

export function entriKode(kode) {
  return PETA_KODE.get(kode) ?? null
}

/** Alamat yang dibuka menu sebuah layar: tab pertamanya kalau bertab. */
export function alamatUtama(entri) {
  return entri.tab ? `${entri.alamat}/${entri.tab[0]}` : entri.alamat
}

/** Semua alamat sebuah layar: satu per tab, atau alamatnya sendiri. */
export function semuaAlamat(entri) {
  if (!entri.alamat) return []
  return entri.tab ? entri.tab.map((tab) => `${entri.alamat}/${tab}`) : [entri.alamat]
}

/**
 * Menu untuk sebuah peran, berkelompok, menurut urutan di RUTE.
 * `[{ kelompok, butir: [entri] }]`
 */
export function menuUntuk(peran) {
  const kelompok = []
  for (const e of RUTE) {
    if (!e.menu || !boleh(peran, e)) continue
    let k = kelompok.find((x) => x.kelompok === e.menu)
    if (!k) kelompok.push(k = { kelompok: e.menu, butir: [] })
    k.butir.push(e)
  }
  return kelompok
}

/** Kode butir menu yang menyala saat `entri` dibuka: dirinya, atau induknya. */
export function kodeMenu(entri) {
  let e = entri
  while (e && !e.menu && e.induk) e = entriKode(e.induk)
  return e?.menu ? e.kode : null
}

/**
 * `lanjut` dari alamat masuk hanya boleh menunjuk ke dalam aplikasi ini. Yang lain
 * (`//situs.lain`, `https://…`, alamat masuk itu sendiri) dibuang, supaya tautan masuk
 * tidak bisa dipakai melempar orang ke situs lain.
 */
export function lanjutAman(lanjut) {
  if (typeof lanjut !== 'string' || !lanjut.startsWith('/')) return null
  if (lanjut.startsWith('//') || lanjut.startsWith('/\\')) return null
  if (lanjut === ALAMAT_MASUK || lanjut.startsWith(`${ALAMAT_MASUK}?`)) return null
  return lanjut
}
